// extracted by mini-css-extract-plugin
module.exports = {"ImageContainer":"ImageContainer_ImageContainer__2jgjQ","ImageLarge":"ImageContainer_ImageLarge__1tH09"};